import React, { useCallback, useContext, useEffect } from 'react'
import { PerformAssessmentStyles } from './Style'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { performAssessmentHooks, TooltipMessage } from '.'
import { Button } from 'components/Form'
import { alerts, categories } from 'keys'
import { isString } from 'lodash'
import { highGradeSteps } from './hooks/useSteps'
import { useSelector } from 'react-redux'
import { useAlert } from 'components/Alerts/hooks'
import { AnimatePresence } from "motion/react"
import AssessmentDetails from '../Assessment/AssessmentDetails'
import Tooltip from './Tooltip'

const PerformAssessment = () => {
    const { isLoading, isHighGrade, canvasRef, tooltipOpen, setTooltipOpen, stopRecord, startRecord, currentStep, isRecording, assessmentDef } = useContext(PerformAssessmentContext)
    const { testTaker = {} } = useSelector(state => state.testTaker)

    const steps = performAssessmentHooks.useSteps()
    const { setAlerts } = useAlert()

    const Component = steps[currentStep].component

    let categoryName = assessmentDef?.category_name || categories.BIBLICAL_TEXT
    let tooltip =
        steps[currentStep].tooltip?.[assessmentDef?.category_name] ||
        (isString(steps[currentStep].tooltip) ? steps[currentStep].tooltip : null) ||
        null

    if (isHighGrade)
        tooltip = highGradeSteps[assessmentDef?.visible_type]?.[currentStep]?.[testTaker.gender]

    const handleTooltip = useCallback(() => {
        setTooltipOpen(!tooltipOpen)
        setTimeout(() => {
            setTooltipOpen(false)
        }, 6000);
    }, [tooltipOpen])

    const openExitScreenAlert = useCallback(() => {
        setAlerts(alerts.exitScreen, true)
    }, [])

    return (
        <PerformAssessmentStyles>
            <AnimatePresence mode="wait">

                {(!tooltip || isLoading) ||
                    <div className='description-tooltip'>
                        <Tooltip handleTooltip={handleTooltip} tooltipOpen={tooltipOpen} tooltip={tooltip} />
                    </div>}
                <div className='perform-assessment-header'>
                    <div className='wrap-waves-and-button'>
                        <Button action={openExitScreenAlert} className="solid-round2" size="small" color="dark" label="סיום המבדק" />
                        {/* <div className='wrap-play-pause'>
                        {currentStep == 3 &&
                            categoryName != categories.MULTIPLE_CHOICE_QUESTIONS &&
                            <Button size="small" color="gray" label={isRecording ? "הפסק הקלטה" : "המשך הקלטה"} action={isRecording ? stopRecord : startRecord}
                            />}
                    </div> */}
                        <div style={{ height: 32, width: 100 }}>
                            <canvas className={isRecording ? 'waves' : ''} ref={canvasRef} width={100} height={32}></canvas>
                        </div>
                    </div>
                    <div className='wrap-assessment-details'>
                        <AssessmentDetails />
                    </div>
                </div>
                <Component />
            </AnimatePresence>
        </PerformAssessmentStyles>
    )
}

export default PerformAssessment